module.exports = __webpack_public_path__ + "static/media/arrow_yellow.586c5d74.svg";